import styled from 'styled-components'
import { ReactComponent as QuestionIcon } from 'assets/img/question-icon.svg'

export const StyledQuestionIcon = styled(QuestionIcon)`
  margin-left: 10px;
`
